export const BORDER_COLORS = {
  DEFAULT: '#6820B4',
  HALLOWEEN: '#3CCEA2',
  CHRISTMAS: '#89D163',
} as const

export const getBorderColor = (disabled: boolean, bgImageUrl?: string): string => {
  if (disabled || !bgImageUrl) return BORDER_COLORS.DEFAULT

  if (bgImageUrl.includes('halloween')) return BORDER_COLORS.HALLOWEEN
  if (bgImageUrl.includes('christmas')) return BORDER_COLORS.CHRISTMAS

  return BORDER_COLORS.DEFAULT
}
